/* eslint-disable no-undef */
import { useTranslate } from 'hooks/useTranslate';
import { FC, useState } from 'react';

import { RealtyTitle } from 'types';

import { useAddRealtyModal } from '../context/AddRealtyModalContext';

import TitlesViewForm from './TitlesViewForm';
import TitlesTable from './TitlesTable/TitlesTable';

const TitlesView: FC = () => {
  const { t } = useTranslate();

  const [expandedView, setExpandedView] = useState<boolean>(false);

  const { data, actions } = useAddRealtyModal();

  const { titles } = data;

  const handleChangeView = () => {
    setExpandedView((prev) => !prev);
  };

  const handleRemoveTitle = (index: number) => {
    const newTitles = titles.filter((_: RealtyTitle, i: number) => i !== index);

    actions.handleChangeTitles(newTitles);
  };

  return (
    <>
      <div className="row gy-4">
        <div className="col-6 d-flex align-items-center">
          <h5 className="mb-0">{t('Titles')}</h5>
        </div>
        <div className="col-6 text-right">
          <button
            type="button"
            className="badge btn-primary"
            onClick={handleChangeView}
          >
            <em
              className={`icon ni ni-chevron-${expandedView ? 'up' : 'down'}`}
            />
          </button>
        </div>
      </div>

      {expandedView && (
        <>
          <TitlesViewForm />

          {titles?.length > 0 && (
            <TitlesTable
              titles={titles}
              handleRemoveTitle={handleRemoveTitle}
            />
          )}
        </>
      )}
    </>
  );
};

export default TitlesView;
